
import { Options, Vue } from 'vue-class-component'
import Farm from '@/farm/Farm'
import ValueMeter from '@/components/ui/ValueMeter.vue'
import PastureView from '@/components/screens/PastureView.vue'
import TextButton from '@/components/ui/TextButton.vue'
import globalState from '@/store/globalState'
import { unref } from 'vue'
import Laboratory from '@/farm/Laboratory'
import Menu from '@/components/screens/Menu.vue'
import SaveSystem from '@/SaveSystem'
import LabView from "@/components/screens/LabView.vue"
import OfficeView from "@/components/screens/OfficeView.vue"
import StartMenu from "@/components/screens/StartMenu.vue"

@Options({
  components: {
    ValueMeter, PastureView, LabView, OfficeView, TextButton, Menu, StartMenu
  },
  props: {
    saveSystem: Object
  },
  emits: ['close'],
  methods: {
    log(msg: any) {
      console.log(msg)
    },
    selectTab(tab: any) {
      if (!this.saveSystem.hasFarm) return

      if (this.selectedTab === 'Menu' && tab !== 'Menu') this.farm.startUpdating()

      this.selectedTab = tab.id
    }
  },
  computed: {
    currentProperties: function() {
      if (this.selectedTab === 'PastureView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'LabView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'OfficeView') {
        return { farm: this.farm }
      }
      if (this.selectedTab === 'Menu') {
        return { saveSystem: this.saveSystem }
      }
    },
    farm: function (): Farm {
      return this.saveSystem.farm
    }
  },
  async created() {
    //await globalState().load()
    //this.saveSystem = new SaveSystem()
    //let farm = new Farm()
    //this.farm = farm
    this.isLoaded = true
  }
})
export default class Milkfarm extends Vue {
  isLoaded = false
  saveSystem!: SaveSystem
  //farm!: Farm
  tabs = [
    { id: 'OfficeView', label: 'Office' },
    { id: 'PastureView', label: 'Pasture' },
    { id: 'LabView', label: 'Lab' }
  ]

  selectedTab: string = 'Menu'
}
